import React from 'react';
import PropTypes from 'prop-types';

import { StepLabel as MUIStepLabel } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

// v5 added an 8px top/bottom padding to both the label text itself and, separately, to the
// whole root when orientation="vertical" — v4 had zero padding in both spots. Restored to 0,
// since together they were pushing vertical steps (e.g. the batch upload wizard) further apart
// than before.
const useStyles = makeStyles()({
  label: {
    padding: 0
  },
  vertical: {
    padding: 0
  }
});

export const StepLabel = props => {
  const { classes } = useStyles();
  return (
    <MUIStepLabel
      {...props}
      classes={{ label: classes.label, vertical: classes.vertical, ...props.classes }}
    />
  );
};

StepLabel.propTypes = {
  StepIconComponent: PropTypes.elementType,
  StepIconProps: PropTypes.object,
  classes: PropTypes.object,
  error: PropTypes.bool,
  icon: PropTypes.node,
  optional: PropTypes.node
};

export default StepLabel;
